import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { callBackend } from "../components/callBackend";
import { Button, Container } from "react-bootstrap";
import Loader from "../components/Loader";

export default function SADetails() {
    const { saID } = useParams();
    const [sa, setSA] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const getDetails = async () => {
        if (!localStorage.getItem("nssc-admin-token")) {
            window.location.href = "/login";
            return;
        }
        setIsLoading(true);
        callBackend({
            method: "GET",
            endpoint: "/admin/sa/" + saID,
            onSuccess: (res) => {
                setSA(res.data);
                setIsLoading(false);
            },
            onError: (error) => {
                console.error("Failed to fetch SA details:", error);
                setSA(null);
                setIsLoading(false);
            },
        });
    };

    useEffect(() => {
        getDetails();
    }, [saID]);

    return (
        <Container style={{ marginTop: "20px", marginBottom: "20px" }}>
            <h1 className="text-center">
                <u>{sa ? `${sa.fName} ${sa.lName}` : "Student Ambassador Details"}</u>
            </h1>

            {isLoading ? (
                <Loader />
            ) : sa ? (
                <div>
                    <h2>SAID - {saID}</h2>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "10px",
                        }}
                    >
                        <div>
                            <p>
                                Email : <a href={"mailto:" + sa.email}>{sa.email}</a>
                            </p>
                            <p>
                                Phone : <a href={"tel:" + sa.phone}>{sa.phone}</a>
                            </p>
                            <p>Gender : {sa.gender}</p>
                        </div>
                        <div>
                            <p>College : {sa.college}</p>
                            <p>Level : {sa.level}</p>
                            <p>
                                City/State : {sa.city}, {sa.state}
                            </p>
                        </div>
                        <div>
                            <p>Successful Payments: {sa.paidCount}</p>
                            <p>Age : {sa.age}</p>
                            <p>Count : {sa.pids.length}</p>
                        </div>
                        <div>
                            Registration through refernece link :{" "}
                            <a
                                href={`https://nssc.in/register/${saID}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {`https://nssc.in/register/${saID}`}
                            </a>
                        </div>
                        <div style={{ width: "100%" }}>
                            PIDs:
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "5px",
                                }}
                            >
                                {sa.pids.map((pid, idx) => (
                                    <Link key={idx} to={"/participant/" + pid}>
                                        <Button variant="outline-primary">{pid}</Button>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <p className="text-center mt-4">
                    Could not find details for this Student Ambassador.
                </p>
            )}
        </Container>
    );
}